import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { SimpleGrid } from "@mantine/core";
import { useAtomValue } from "jotai";

import {
  AsyncState,
  BusinessUnitCard,
  PageHeader,
} from "@prostocheck/controls-web";
import { useCashRegisters, useSession } from "@prostocheck/data-web";
import {
  apiErrorAtom,
  apiLoadingAtom,
  cashRegistersAtom,
  groupRegistersByBusinessUnit,
} from "@prostocheck/shared";

export const BusinessUnitsPage = () => {
  const { t } = useTranslation();
  const { session } = useSession();

  const { getCashRegisters } = useCashRegisters();
  const fetchedRegisters = useAtomValue(cashRegistersAtom);
  const isLoading = useAtomValue(apiLoadingAtom);
  const errorResult = useAtomValue(apiErrorAtom);
  const registers = fetchedRegisters.length > 0 ? fetchedRegisters : (session?.registers ?? []);
  const businessUnits = groupRegistersByBusinessUnit(registers);

  useEffect(() => {
    void getCashRegisters();
  }, [getCashRegisters]);

  return (
    <>
      <PageHeader
        title={t("businessUnits.title")}
        description={t("businessUnits.description")}
      />

      {errorResult && !isLoading && (
        <div className="mb-6">
          <AsyncState
            isLoading={false}
            errorResult={errorResult}
            onRetry={getCashRegisters}
          />
        </div>
      )}

      <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing="md">
        {businessUnits.map(businessUnit => (
          <BusinessUnitCard
            key={businessUnit.taxObjectId}
            businessUnit={businessUnit}
          />
        ))}
      </SimpleGrid>
    </>
  );
};
